import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';
import { authInterceptor } from './guards/auth.interceptor';
import { es } from 'primelocale/es.json';
import { HttpErrorInterceptor } from './shared/interceptor/http-error.interceptor';


const customAura = {
  ...Aura,
  semantic: {
    ...Aura.semantic,
    primary: {
      ...Aura.semantic?.primary,
      50: '#eef5fe',
      100: '#d9e8fc',
      200: '#b5d1f8',
      300: '#86b3f1',
      400: '#4f8fe6',
      500: '#1e6fd9', // Color principal
      600: '#1858b0',
      700: '#154a91',
      800: '#133d76',
      900: '#0f3160',
      950: '#0b2545',
    },
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      translation: es,
      theme: {
        preset: customAura,
        options: {
          prefix: 'arc',
          darkModeSelector: '.my-app-dark', 
          scope: 'primeng',
        },
      },
    }),
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    }
  ],
};